import styled from "@emotion/styled";
import { media } from "../../components/Window/themes";
const Message = {
    OuterWrapper: styled.div `
    padding: 0.3em 0;
    position: relative;

    :hover {
      background-color: ${({ theme }) => theme.color.backgroundHover};
      .message-actions {
        display: flex;
      }
    }
    ${(props) => {
        var _a;
        return props.showActions
            ? `  background-color: ${(_a = props.theme) === null || _a === void 0 ? void 0 : _a.color.backgroundHover};
              .message-actions {
                display: flex;
              }`
            : ``;
    }};
    &.focused,
    :focus-within,
    :focus {
      outline: none;
      border: 2px solid;
      border-color: ${({ theme }) => theme.color.backgroundBrand};

      #enter {
        display: flex;
      }
      #escape {
        display: flex;
      }
    }
  `,
    Wrapper: styled.div `
    display: flex;
    position: relative;
    padding: ${({ hasAvatar }) => hasAvatar ? "0 2em" : "0 2em 0 0.2em"};
    font-size: 0.9rem;
    line-height: 1.4;
  `,
    Sender: styled.span `
    font-weight: bold;
    margin-bottom: 0.5em;
  `,
    Header: styled.div `
    display: flex;
    margin-bottom: 0;
    line-height: 1;
  `,
    Gutter: styled.div `
    flex: 0 1 auto;
    flex-basis: 100%;
    min-width: 0;
    word-break: break-word;
    margin-left: ${({ size }) => size === "small" ? "1em" : "5rem"};
    ${media.medium} {
      margin-left: ${({ size }) => size === "small" ? "1em" : "4.5rem"};
    }
  `,
    EmojiReactionWrapper: styled.div `
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    line-height: normal;
    word-break: break-word;
    margin-left: 5.2rem;
    ${media.medium} {
      margin-left: 4.5rem;
    }
  `,
    EmojiReaction: styled.p `
    margin: 0.5rem 0.2rem 0 !important;
    font-size: medium;
    border: ${(props) => {
        var _a;
        return props.isEmojiSelected
            ? `1px solid ${(_a = props.theme) === null || _a === void 0 ? void 0 : _a.color.borderReactionSelected}`
            : "1px solid transparent";
    }};
    background-color: ${(props) => {
        var _a, _b;
        return props.isEmojiSelected
            ? (_a = props.theme) === null || _a === void 0 ? void 0 : _a.color.backgroundReactionSelected
            : (_b = props.theme) === null || _b === void 0 ? void 0 : _b.color.backgroundReaction;
    }};
    padding: 0 0.35rem;
    border-radius: 0.75rem;
    cursor: pointer;
    user-select: none;
    &:hover {
      border: ${(props) => {
        var _a, _b;
        return props.isEmojiSelected
            ? `1px solid ${(_a = props.theme) === null || _a === void 0 ? void 0 : _a.color.borderReactionSelected}`
            : `1px solid ${(_b = props.theme) === null || _b === void 0 ? void 0 : _b.color.borderReactionHover}`;
    }};
      background-color: ${(props) => {
        var _a, _b;
        return props.isEmojiSelected
            ? (_a = props.theme) === null || _a === void 0 ? void 0 : _a.color.backgroundReactionSelected
            : (_b = props.theme) === null || _b === void 0 ? void 0 : _b.color.backgroundReactionHover;
    }};
    }
  `,
    EmojiReactionNumber: styled.span `
    font-size: 0.8rem;
    margin-left: 0.2rem;
    color: ${(props) => props.isEmojiSelected ? "#439cd1!important" : "grey"};
  `,
    Emoji: styled.svg `
    :hover {
      stroke: ${({ theme }) => theme.color.danger};
    }
  `,
    Enter: styled.p `
    position: absolute;
    top: calc(100% - 0px);
    right: 1em;
    display: none;
    padding: 0.3em 0.5em;
    background: ${({ theme }) => theme.color.backgroundHover};
    border: solid 0.1em ${({ theme }) => theme.color.backgroundAccent};
    border-radius: 0.2em;
  `,
};
export default Message;
//# sourceMappingURL=Message.styled.js.map